import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { certificateList } from '../../data/localData'

function CertificateList() {
    return (
        <div className='home-gap'>
            <div className='home-certificates-list d-grid'>
                <Container className='home-gap'>
                    <h1 className='m-0 fs-md-24 fw-semibold text-center pb-3 pb-sm-4'>Our Certificates</h1>
                    <Row>
                        <Col className='col-12 flex-between-align'>
                            {
                                certificateList.map((image, index) => {
                                    return (
                                        <div className='img-holder'>
                                            <img src={image} alt="" />
                                        </div>
                                    )
                                })
                            }
                        </Col>
                    </Row>
                </Container>
                <span className='home-gap' />
            </div>
        </div>
    )
}

export default CertificateList